module.exports = __webpack_public_path__ + "img/Path 20 Copy@3x.4c5631ce.png";